function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "tommy1");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "tommy1"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  fill: "#040C2B",
  points: "0 0.3854 0 4.1584 10.119 4.1584 10.119 29.6284 14.321 29.6284 14.321 4.1584 24.439 4.1584 24.439 0.3854"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.2692,26.1533 C111.8282,26.1533 116.6742,21.3933 116.6742,15.0073 C116.6742,8.5753 111.8282,3.8583 105.2692,3.8583 C98.7512,3.8583 93.9062,8.5753 93.9062,15.0073 C93.9062,21.3933 98.7512,26.1533 105.2692,26.1533 M105.2692,0.0003 C114.9152,0.0003 121.0042,6.8603 121.0042,15.0073 C121.0042,22.8973 115.0862,30.0113 105.1822,30.0113 C95.6212,30.0113 89.5762,22.9393 89.5762,15.0073 C89.5762,6.9023 95.7932,0.0003 105.2692,0.0003",
  id: "Fill-2",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  fill: "#040C2B",
  points: "213.4099 29.6279 209.2089 29.6279 209.2089 6.8599 209.1219 6.8599 200.1189 18.1809 199.4319 18.1809 190.4289 6.8599 190.3429 6.8599 190.3429 29.6279 186.1409 29.6279 186.1409 0.3859 190.0859 0.3859 199.7759 12.3919 209.5089 0.3859 213.4099 0.3859"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-6",
  fill: "#040C2B",
  points: "305.8166 29.6279 301.6146 29.6279 301.6146 6.8599 301.5286 6.8599 292.5236 18.1809 291.8386 18.1809 282.8336 6.8599 282.7496 6.8599 282.7496 29.6279 278.5456 29.6279 278.5456 0.3859 282.4906 0.3859 292.1816 12.3919 301.9156 0.3859 305.8166 0.3859"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-8",
  fill: "#040C2B",
  points: "391.7897 0.3857 396.8507 0.3857 386.0007 14.1927 386.0007 29.6277 381.8007 29.6277 381.8007 14.1497 370.9527 0.3857 376.0117 0.3857 383.8567 10.4627"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-11",
  fill: "#040C2B",
  points: "24.78 224.5908 20.582 224.5908 20.582 211.8578 4.203 211.8578 4.203 224.5908 0 224.5908 0 195.3488 4.203 195.3488 4.203 208.0828 20.582 208.0828 20.582 195.3488 24.78 195.3488"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-13",
  fill: "#040C2B",
  points: "62.545 224.591 66.743 224.591 66.743 195.349 62.545 195.349"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-15",
  fill: "#040C2B",
  points: "108.7121 220.8163 121.9201 220.8163 121.9201 224.5903 104.5091 224.5903 104.5091 195.3483 108.7121 195.3483"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-16",
  fill: "#040C2B",
  points: "175.2966 199.121 163.8886 199.121 163.8886 207.225 175.2966 207.225 175.2966 211 163.8886 211 163.8886 224.591 159.6856 224.591 159.6856 195.349 175.2966 195.349"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-17",
  fill: "#040C2B",
  points: "213.062 224.591 217.26 224.591 217.26 195.349 213.062 195.349"
}), /*#__PURE__*/React.createElement("path", {
  d: "M281.738,222.5742 C277.837,224.2902 274.666,224.9742 270.595,224.9742 C261.633,224.9742 255.026,218.7152 255.026,210.1422 C255.026,201.5242 261.802,194.9632 270.722,194.9632 C274.152,194.9632 276.55,195.5202 281.14,197.4502 L281.14,201.6932 C277.71,199.8082 274.152,198.8212 270.637,198.8212 C264.29,198.8212 259.356,203.6682 259.356,210.0122 C259.356,216.5292 264.248,221.1162 271.193,221.1162 C273.464,221.1162 275.523,220.6022 277.54,219.9592 L277.54,213.9562 L271.918,213.9562 L271.918,210.1842 L281.738,210.1842 L281.738,222.5742 Z",
  id: "Fill-18",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-19",
  fill: "#040C2B",
  points: "336.0993 199.121 323.7063 199.121 323.7063 207.956 335.6703 207.956 335.6703 211.727 323.7063 211.727 323.7063 220.816 336.4863 220.816 336.4863 224.591 319.5033 224.591 319.5033 195.349 336.0993 195.349"
}), /*#__PURE__*/React.createElement("path", {
  d: "M378.4548,208.1249 L381.1548,208.1249 C385.6598,208.1249 386.9458,205.8119 386.9038,203.3659 C386.8558,200.6219 385.2308,198.9509 381.1548,198.9509 L378.4548,198.9509 L378.4548,208.1249 Z M381.6258,195.3489 C387.5438,195.3489 391.2338,198.4799 391.2338,203.5379 C391.2338,206.9259 389.4758,209.4539 386.3428,210.6979 C388.9998,212.4559 390.6308,215.1579 392.8588,218.8029 C394.1028,220.8159 394.8338,221.8049 396.8508,224.5909 L391.8318,224.5909 L387.9728,218.5879 C384.1138,212.5849 382.3558,211.8989 380.2118,211.8989 L378.4548,211.8989 L378.4548,224.5909 L374.2518,224.5909 L374.2518,195.3489 L381.6258,195.3489 Z",
  id: "Fill-20",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-21",
  fill: "#040C2B",
  points: "216.703 83.243 396.85 83.243 396.85 53.999 216.703 53.999"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-22",
  fill: "#040C2B",
  points: "216.703 170.978 396.85 170.978 396.85 141.733 216.703 141.733"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-23",
  fill: "#ECECEB",
  points: "216.704 141.733 306.777 141.733 306.777 83.243 216.704 83.243"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-24",
  fill: "#BA001D",
  points: "306.776 141.733 396.85 141.733 396.85 83.243 306.776 83.243"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-25",
  fill: "#040C2B",
  points: "0.001 78.37 180.148 78.37 180.148 53.999 0.001 53.999"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-26",
  fill: "#ECECEB",
  points: "0.001 112.488 180.148 112.488 180.148 78.37 0.001 78.37"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-27",
  fill: "#040C2B",
  points: "0 170.978 180.147 170.978 180.147 146.607 0 146.607"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-28",
  fill: "#BA001D",
  points: "0 146.607 180.147 146.607 180.147 112.488 0 112.488"
})));

var SvgTommy1 = function SvgTommy1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "397px",
    height: "225px",
    viewBox: "0 0 397 225",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTommy1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tommy1.bc37b049.svg";
export { ForwardRef as ReactComponent };